<template>
  <div class="gp-content">
    <content-tab-bar :tabs="tabs"></content-tab-bar>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import ContentTabBar from '@/components/ContentTabBar.vue';

export default {
  name: 'AdminDashBoards',
  components: { ContentTabBar },
  computed: {
    tabs() {
      return [
        {
          label: 'Foo',
          link: {
            name: 'admin.organizations.index',
          },
          icon: 'circle',
        },
      ];
    },
  },
};
</script>
